import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../App';
import { toast } from 'sonner';

const Auth = ({ setUser }) => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = isLogin ? '/auth/login' : '/auth/register';
      const response = await api.post(endpoint, { email, password });
      
      localStorage.setItem('token', response.data.token);
      setUser(response.data.user);
      toast.success(isLogin ? 'Welcome back!' : 'Account created!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ledger-bone grid grid-cols-1 md:grid-cols-2">
      {/* Left side - Form */}
      <div className="flex items-center justify-center p-8 relative noise-overlay">
        <div className="w-full max-w-md space-y-8 relative z-10">
          <div>
            <h1 className="font-serif text-4xl font-bold text-ledger-green mb-2" data-testid="auth-title">
              {isLogin ? 'Welcome Back' : 'Get Started Free'}
            </h1>
            <p className="font-mono text-sm text-gray-600">
              {isLogin ? 'Sign in to access your statements' : 'Create account and get 1 free extraction'}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="auth-form">
            <div>
              <label className="font-mono text-xs uppercase tracking-widest text-gray-700 block mb-2" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border-2 border-black/10 rounded-none p-3 font-mono text-sm focus:outline-none focus:border-ledger-green"
                placeholder="you@example.com"
                required
                data-testid="email-input"
              />
            </div>

            <div>
              <label className="font-mono text-xs uppercase tracking-widest text-gray-700 block mb-2" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border-2 border-black/10 rounded-none p-3 font-mono text-sm focus:outline-none focus:border-ledger-green"
                placeholder="••••••••"
                required
                data-testid="password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-ledger-green text-white rounded-none hover:bg-ledger-green/90 uppercase tracking-widest text-xs py-4 px-8 font-mono disabled:opacity-50"
              data-testid="submit-btn"
            >
              {loading ? 'Processing...' : (isLogin ? 'Sign In' : 'Create Account')}
            </button>
          </form>

          <div className="text-center">
            <button
              onClick={() => setIsLogin(!isLogin)}
              className="font-mono text-xs text-ledger-green hover:underline"
              data-testid="toggle-auth-btn"
            >
              {isLogin ? "Don't have an account? Sign up" : 'Already have an account? Sign in'}
            </button>
          </div>
        </div>
      </div>

      {/* Right side - Image */}
      <div className="hidden md:block relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1537655949728-d4e1c7c7bf90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwb2ZmaWNlJTIwZGVzayUyMHRvcCUyMHZpZXd8ZW58MHx8fHwxNzY1MDc3MzA5fDA&ixlib=rb-4.1.0&q=85"
          alt="Minimalist office essentials"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-ledger-green/20" />
      </div>
    </div>
  );
};

export default Auth;